import { render, staticRenderFns } from "./TheNuevoCategoriaLinae.vue?vue&type=template&id=66314bd5&"
import script from "./TheNuevoCategoriaLinae.vue?vue&type=script&lang=js&"
export * from "./TheNuevoCategoriaLinae.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports